import { brand } from '../../../theme/themePrimitives';
import CustomModal from '../../modals';
import EmailField from './email_fields';
import SMSFieldComponent from './sms_fields';
import { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { ChatBubbleOutline, MailOutlineOutlined } from '@mui/icons-material';

interface ShareEventModalProps {
    open: boolean;
    onClose: () => void;
}

const ShareEventModal = ({ open, onClose }: ShareEventModalProps) => {
    const [selectedFlag, setSelectedFlag] = useState<'email' | 'phone' | null>(null);
    const [showFields, setShowFields] = useState<boolean>(false);
    const shareHandler = () => {
        setShowFields(true);
    };

    const modalTitle = showFields && selectedFlag === 'email' ? 'Inviting Email' : showFields && selectedFlag === 'phone' ? 'SEND SMS' : 'Share your invite link';

    return <CustomModal open={open} handleClose={onClose} title={modalTitle}>
        {showFields && selectedFlag === 'email'
            ? <EmailField onCancelHandler={() => setShowFields(false)} />
            : showFields && selectedFlag === 'phone'
                ? <SMSFieldComponent onCancelHandler={() => setShowFields(false)} />
                : <>
                    <Box display="flex" gap={1} alignItems="center" justifyContent="center" my={2}>
                        {
                            [
                                {
                                    icon: <MailOutlineOutlined />,
                                    label: 'Share link as email',
                                    flag: 'email'
                                },
                                {
                                    icon: <ChatBubbleOutline />,
                                    label: 'Share link as SMS',
                                    flag: 'phone'
                                }
                            ].map((item, index) => <Box
                                key={index}
                                display="flex"
                                border={`1px solid ${selectedFlag === item.flag ? brand[300] : '#eee'}`}
                                bgcolor={selectedFlag === item.flag ? brand[50] : 'transparent'}
                                borderRadius={1}
                                p={3}
                                alignItems="center"
                                justifyContent="center"
                                onClick={() => setSelectedFlag(item.flag as 'email' | 'phone')}
                                sx={{
                                    '&:hover': {
                                        backgroundColor: '#f0f0f0',
                                        border: '1px solid #111',
                                        cursor: 'pointer'
                                    }
                                }}
                            >
                                <Box>{item.icon}</Box>
                                <Typography>{item.label}</Typography>
                            </Box>)
                        }
                    </Box>
                    <Box display="flex" gap={2}>
                        <Button variant="outlined" size="large" fullWidth color="secondary" onClick={onClose}>
                            Cancel
                        </Button>
                        <Button variant="contained" size="large" fullWidth onClick={shareHandler}>
                            Share
                        </Button>
                    </Box>
                </>}
    </CustomModal>;
};

export default ShareEventModal;